export const SITE_ORIGIN = "https://lotcamp.earthboundmartian.com";
export const SITE_NAME = "LotCamp";
export const SITE_TAGLINE = "Sleep at the show.";
export const SITE_DESCRIPTION =
  "A free map of outdoor, RV-friendly music festivals — death metal to pagan gatherings — with dates, lot notes, and trip planning.";
export const ORG_ORIGIN = "https://earthboundmartian.com";
export const ORG_NAME = "Earthbound Martian, LLC";
export const CONTACT_EMAIL = "lotcamp@earthboundmartian.com";
